import { FC, useEffect } from 'react';
import { TemplateName } from 'types';
import { useFormContext } from 'react-hook-form';
import { useAludelTemplates } from 'hooks/query/useAludelTemplates';
import {
  mapTemplateNameToDescription,
  mapTemplateNameToName
} from 'utils/aludelMappings';
import { Box, GridItem, Heading, SimpleGrid, Text } from '@chakra-ui/react';

const SelectAludelTemplate: FC = () => {
  const { data } = useAludelTemplates();
  const { watch, setValue } = useFormContext();

  const templateId = watch('templateId');

  useEffect(() => {
    if (data) {
      setValue('templateId', data[Object.keys(data)[0]].id);
      setValue('templateName', data[Object.keys(data)[0]].name);
    }
  }, [data, setValue]);

  return (
    <Box p={10} mb={8} borderRadius='xl' borderWidth='1px'>
      <Heading size='md' mb={6}>
        Select Reward Contract
      </Heading>

      {data && (
        <SimpleGrid columns={[1, 2, 3]} spacing={8}>
          {Object.keys(data).map((d) => (
            <GridItem>
              <Box
                p='5'
                height='100%'
                borderWidth='1px'
                rounded='md'
                cursor='pointer'
                role='button'
                onClick={() => {
                  setValue('templateId', data[d].id);
                  setValue('templateName', data[d].name);
                }}
                borderColor={
                  data[d].id === templateId ? 'cyan.300' : 'gray.300'
                }
              >
                <Heading size='md' my='2'>
                  {mapTemplateNameToName[data[d].name as TemplateName]}
                </Heading>
                <Text color='gray.300'>
                  {mapTemplateNameToDescription[data[d].name as TemplateName]}
                </Text>
              </Box>
            </GridItem>
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default SelectAludelTemplate;
